import React, { memo } from 'react';
import { Divider as MuiDivider } from '@mui/material';
import Box, { IBoxProps } from 'component/layoutComponents/Box';

const Divider = ({
  orientation = 'vertical',
  ...restBoxProps
}: {
  orientation?: 'vertical' | 'horizontal';
} & IBoxProps) => {
  return (
    <Box
      as={"div" as any}
      height="30px"
      borderColor="transparent"
      {...restBoxProps}
    >
      <MuiDivider orientation={orientation} />
    </Box>
  );
};

export default memo(Divider);
